<template>
    <div
        v-if="isShow"
        class="switchDesignV2"
        :class="{
            loadingState: disabled,
        }"
        @click="handleSwitch"
    >
        <span class="switchDesignV2__icon">
            <vector-icon :icon="'logo-blue-v2'" />
        </span>
        <span class="switchDesignV2__label"> Try Salesmsg 2.0 </span>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import FeatureablesMixin from 'mixins/featureables';
import Form from 'core/Form';

export default {
    mixins: [FeatureablesMixin],

    data() {
        return {
            disabled: false,
        };
    },

    computed: {
        isShow() {
            if (!this.user?.id) return false;
            if (this.featureFlags.show_new_design_only) return false;
            if (this.isOldDesignConversation) return true;

            return this.isNewDesign;
        },

        isNewDesign() {
            if (this.$route.name === 'widget.calling') return false;
            if (!this.$route.name && this.$route.fullPath === '/') return false;
            if (this.$route.name === 'auth.oauth') return false;

            return false;
        },

        isOldDesignConversation() {
            return !this.hasFeatureUser('salesmsg-design-v2');
        },

        ...mapState(stores.User, ['user']),
        ...mapState(stores.Organization, ['organization', 'featureFlags']),
    },

    methods: {
        async handleSwitch() {
            if (this.disabled) return;

            this.disabled = true;

            const form = new Form({
                featureKey: 'salesmsg-design-v2',
                settingsKey: 'active',
                value: true,
            });

            await this.$store.dispatch('updateUsersSettings', form);

            window.sessionStorage.removeItem('newSession');
            window.location.reload();
        },
    },
};
</script>

<style lang="scss">
@import 'style';
</style>
